import { Close } from "@mui/icons-material";
import { Box, CircularProgress, IconButton, MenuItem, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import swal from "sweetalert";

const DownloadFarmersData = ({
  districtValue,
  crop,
  setAnchorEl,setLoadingCsv
}) => {
  const handleDownload = (url, filename, timeout = 1500) => {
      swal("Large CSV file (~1-2 min). Check Downloads folder.", {
        buttons: false,
        icon: "info",
        title: "Download Started",
        timer: 6000,
             });
    setAnchorEl(null);
    // setLoadingCsv(true);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // setTimeout(() => setLoadingCsv(false), timeout);
  };
//   const handleDownload = async (url, filename) => {
//   try {
//     setAnchorEl(null);
//     setLoadingCsv(true);

//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         Accept: "text/csv",
//       },
//     });

//     if (!response.ok) {
//       throw new Error("Failed to download CSV");
//     }

//     const blob = await response.blob();
//     const blobUrl = window.URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.href = blobUrl;
//     link.download = filename;

//     document.body.appendChild(link);
//     link.click();

//     link.remove();
//     window.URL.revokeObjectURL(blobUrl);
//   } catch (error) {
//     console.error(error);
//   } finally {
//     setLoadingCsv(false);
//   }
// };

// const handleDownload = (url) => {
//   setLoadingCsv(true);

//   const iframe = document.createElement("iframe");
//   iframe.style.display = "none";

//   iframe.onload = () => {
//     setLoadingCsv(false); 
//     iframe.remove();
//   };

//   iframe.src = url;
//   document.body.appendChild(iframe);
// };

//  const [open, setOpen] = useState(false);

//  const handleDownload = (csvUrl) => {
//   const newTab = window.open(csvUrl, "_blank", "noopener,noreferrer");

//   if (!newTab) {
//     toast.error("Popup blocked! Please allow popups.");
//     return; 
//   }

//   setOpen(true);

//   setTimeout(() => {
//     setOpen(false);
//     toast.success("Download started! Check your downloads folder.");
//   }, 1800);
// };

// const [downloadProgress, setDownloadProgress] = useState(false);

// const downloadCheckInterval = useRef(null);

// const handleDownload = (url, filename) => {
//   setLoadingCsv(true);

//   const link = document.createElement("a");
//   link.href = url;
//   link.download = filename;
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);

//   // Listen ONLY for user actions that happen post-download
//   const events = ['click', 'scroll', 'keydown', 'focus'];
  
//   const handler = () => {
//     setLoadingCsv(false);
//     events.forEach(event => window.removeEventListener(event, handler));
//   };

//   // User will naturally interact after download completes
//   events.forEach(event => window.addEventListener(event, handler, { once: true }));
// };
// const handleDownload = (url, filename) => {
//     swal("Large CSV file (~1-2 min). Check Downloads folder.", {
//         buttons: false,
//         icon: "info",
//         title: "Download Started",
//         timer: 6000,
//              });

//   const link = document.createElement("a");
//   link.href = url;
//   link.download = filename;
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };




  const district_name = districtValue || "";
  const crop_name = crop || "";

  return (
    <>
      {/* <MenuItem
        onClick={() =>
          handleDownload(
            `https://onboarding.agrani.tech/api/v1/onboarding/baseline-assessment-csv?district_name=${district_name}&crop_name=${crop_name}`,
            "baseline-assessment.csv"
          )
        }
      >
        Farmer Data
      </MenuItem> */}
  
      <MenuItem
        onClick={() => {
          const timeout = crop_name ? 1000 : district_name ? 6500 : 120000;
          handleDownload(
            `https://onboarding.agrani.tech/api/v1/onboarding/baseline-assessment-csv?form_name=crop_level&district_name=${district_name}&crop_name=${crop_name}`,
            "baseline-assessment-crop.csv",timeout
          );
        }}
      >
        Crop Level
      </MenuItem>

      <MenuItem
        onClick={() =>
          handleDownload(
            `https://onboarding.agrani.tech/api/v1/onboarding/baseline-assessment-csv?form_name=economic&district_name=${district_name}&crop_name=${crop_name}`,
            "baseline-assessment-economic.csv",
            2000
          )
        }
      >
        Economic
      </MenuItem>

      <MenuItem
        onClick={() =>
          handleDownload(
            `https://onboarding.agrani.tech/api/v1/onboarding/baseline-assessment-csv?form_name=environmental&district_name=${district_name}&crop_name=${crop_name}`,
            "baseline-assessment-environmental.csv",
            2000
          )
        }
      >
        Environmental
      </MenuItem>

      <MenuItem
        onClick={() =>
          handleDownload(
            `https://onboarding.agrani.tech/api/v1/onboarding/baseline-assessment-csv?form_name=social&district_name=${district_name}&crop_name=${crop_name}`,
            "baseline-assessment-social.csv",
            1500
          )
        }
      >
        Social
      </MenuItem>
    {/* <Modal open={open} onClose={() => setOpen(false)}>
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      bgcolor: "white",
      p: 4,
      borderRadius: 2,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    }}
  >
    <CircularProgress />
    <Typography sx={{ mt: 2 }}>Preparing your CSV...</Typography>
  </Box>
</Modal> */}
    </>
  );
};

export default DownloadFarmersData;
